import { IconProps } from "./IconProps";

export const RepairsIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M5.00001 5.00002L8.75001 8.75002M5.00001 5.00002H2.50001L1.66667 2.50002L2.50001 1.66669L5.00001 2.50002V5.00002ZM16.0492 2.2842L13.8595 4.47388C13.5295 4.80389 13.3645 4.9689 13.3026 5.15917C13.2483 5.32654 13.2483 5.50683 13.3026 5.6742C13.3645 5.86447 13.5295 6.02948 13.8595 6.35949L14.0572 6.55721C14.3872 6.88723 14.5522 7.05223 14.7425 7.11406C14.9099 7.16844 15.0902 7.16844 15.2575 7.11406C15.4478 7.05223 15.6128 6.88723 15.9428 6.55721L17.9911 4.50895C18.2117 5.04576 18.3333 5.63368 18.3333 6.25002C18.3333 8.78133 16.2813 10.8334 13.75 10.8334C13.4448 10.8334 13.1466 10.8035 12.8581 10.7466C12.453 10.6667 12.2505 10.6268 12.1277 10.639C11.9971 10.652 11.9328 10.6716 11.8171 10.7335C11.7083 10.7917 11.5991 10.9009 11.3809 11.1192L5.41667 17.0833C4.72632 17.7737 3.60703 17.7737 2.91667 17.0833C2.22632 16.393 2.22632 15.2737 2.91667 14.5833L8.88086 8.61916C9.09915 8.40088 9.20829 8.29173 9.26652 8.18293C9.32842 8.06725 9.348 8.00291 9.361 7.87236C9.37324 7.74957 9.33329 7.54701 9.25339 7.14189C9.1965 6.8534 9.16667 6.55519 9.16667 6.25002C9.16667 3.71872 11.2187 1.66669 13.75 1.66669C14.5879 1.66669 15.3733 1.89154 16.0492 2.2842ZM10 12.5L14.5833 17.0833C15.2737 17.7736 16.393 17.7736 17.0833 17.0833C17.7737 16.3929 17.7737 15.2736 17.0833 14.5833L13.3128 10.8128C13.0458 10.7875 12.7856 10.7394 12.534 10.6703C12.2098 10.5813 11.8541 10.6459 11.6164 10.8836L10 12.5Z"
        stroke="#06123D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
